<div class="modal-top">
    <div class="modal-top__inner">
        <shared-circle-btn (onClick)="handleCloseClick($event)" icon="close" feel="dark"></shared-circle-btn>
    </div>
</div>